import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="bg-brand-green text-brand-cream py-24 px-6 border-y border-brand-gold/20" data-id="element-169">
      <div className="max-w-4xl mx-auto text-center" data-id="element-170">
        <FadeIn data-id="element-171">
          <Quote className="w-16 h-16 text-brand-gold/40 mx-auto mb-8" data-id="element-172" />
          <h2 className="text-2xl md:text-4xl font-serif italic font-light leading-relaxed mb-10 text-brand-cream" data-id="element-173">
            "En los primeros 7 días de aplicar el método, notarás cómo la niebla
            mental desaparece. Cuando dejas de operar bajo el modo de
            supervivencia, tu capacidad para detectar y ejecutar negocios se
            multiplica, porque estás operando con el hardware biológico
            optimizado que la mayoría ignora."
          </h2>
          <div className="w-16 h-1 bg-brand-gold mx-auto" data-id="element-174"></div>
        </FadeIn>
      </div>
    </section>;
}